import { QuickstartTheme } from '../../types/theme';
import { ResolvedDeviceFallbackConfig } from '../../types/deviceFallbackTheme';
import { ThemeLogo } from '../ThemeLogo';
import { FallbackStageMedia } from './FallbackStageMedia';

interface UnavailableFallbackProps {
  theme: QuickstartTheme;
  config: ResolvedDeviceFallbackConfig;
}

/**
 * Shown when a campaign disables every platform, so there is no device to hand off to.
 *
 * Deliberately offers no QR, email, or copy affordance: every one of those would promise
 * a way in that does not exist. Only a misconfigured campaign reaches this.
 */
export const UnavailableFallback = ({ theme, config }: UnavailableFallbackProps) => (
  <div
    className='relative flex min-h-screen w-full flex-col overflow-y-auto font-["Inter"]'
    style={{ backgroundColor: config.stageColor }}
  >
    {/* Pixels rather than a share of the stage, unlike the two handoff screens: this one is
      an ordinary centred page with no 16:9 artboard behind it, so there is no stage width
      for a blur to be a fraction of. */}
    <FallbackStageMedia
      theme={theme}
      blur={`${config.backgroundBlurPx}px`}
      scrimOpacity={0.65}
    />

    <div className='relative flex min-h-screen flex-col items-center justify-between px-6 py-8'>
      <div className='flex w-full min-w-0 flex-col items-center gap-3'>
        <ThemeLogo kind='studio' theme={theme} defaultHeight={40} />
        <ThemeLogo kind='game' theme={theme} defaultHeight={56} />
      </div>

      <div className='flex w-full max-w-sm flex-col items-center gap-3 py-8 text-center'>
        <h1 className='text-2xl font-bold text-white'>{config.unavailableHeadline}</h1>
        <p className='text-sm leading-relaxed' style={{ color: config.copyColor }}>
          {config.unavailableSubcopy}
        </p>
      </div>

      <ThemeLogo kind='poweredBy' theme={theme} defaultHeight={20} style={{ opacity: 0.5 }} />
    </div>
  </div>
);
